module.exports = {
  generateWithLocale: url => url,
  generateWithRequestedLocale: url => url,
  generate: url => url,
  getUrlWithLocale: url => url,
  generateWithLanguage: url => url
};
